import { action, observable } from 'mobx'

const initialWizardData = {
  registrationNumber: '',
  registeredName: '',
  registeredAddress: '',
  requiresApproval: false,
  accountingScheme: '',
  active: false,
  SubmissionGatewayId: '', // must be capitalised for back-end,
  submissionGatewaySettingsStartDate: null,
  submissionGatewaySettingsFrequency: null,
  Companies: []
}

export class GettingStartedWizardStore {
  @observable wizardData = initialWizardData

  @action resetWizardData = () => {
    this.wizardData = initialWizardData
  }
}
